import { TransactionHistoryRequestModel } from "api/baseTransactionHistory/TransactionHistoryRequestModel";

export class PackageRegistrationRequestModel extends TransactionHistoryRequestModel {
  code?: string;
  carrier?: Array<string>;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  package?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  toDate?: string;
  store?: Array<string>;
  staff?: Array<string>;
  order?: string;
  isOnlyStore?: string;

  constructor(data?: {
    code?: string;
    carrier?: Array<string>;
    limit?: number;
    page?: number;
    pagination?: boolean;
    phoneNumber?: string;
    status?: number;
    package?: string;
    created?: Record<string, unknown>[];
    fromDate?: string;
    toDate?: string;
    store?: Array<string>;
    staff?: Array<string>;
    order?: string;
    isOnlyStore?: string;
  }) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.fromDate = data?.fromDate;
    this.package = data?.package;
    this.created = data?.created;
    this.store = data?.store;
    this.staff = data?.staff;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
  }
}
